<template>

  <section class="article-search component-container">
    <div class="article-panel-box">
      <div class="article-panel">
        <div class="container-head contain-btn-title">
          <div class="container-head-title">
            <i class="icon-sousuo iconfont"style="color: #39021e;font-size: 25px"></i>
            <span class="subpage-head-text" style="position: absolute;padding-left: 5px;font-size: 14px;color: #606266bd">共有{{ data.list.length }}条搜索结果</span>
            <div style="float: right">
              <common-button size="default" type="cancel" image @click="handleCancelClick()">返回</common-button>
            </div>
          </div>
        </div>

        <div class="container-body">
          <div class="form-body">
            <!--   普通用户 标题，申请日期，状态（保存，审核中，审核完成），当前处理人，催办（催办功能是否能实现）-->
            <!--   管理员 标题，申请人，单位，申请日期，状态，操作-->
            <div class="loud-speaker-list-table-card">
              <el-table
                v-loading="data.tableLoading"
                row-class-name="vertical-align-top" :data="data.list.slice((data.pageNum-1)*data.pageSize,data.pageNum*data.pageSize)"
                :header-cell-style="{ background: '#E5F5F9',fontSize:'16px',color:'#353739' }"
                :row-style="tableRowClassName"
                style="cursor: pointer"
                @row-click="handViewClick"
                @sort-change="sort_change">
                <el-table-column align="left" prop="postTitle" label="标题" min-width="400" sortable="custom">
                  <template slot-scope="scope">
                    <span>{{scope.row.postTitle}}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="createTm" label="发布时间" width="220" sortable="custom">
                  <template slot-scope="scope">
                    <span>{{scope.row.createTm| dateFormat}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="userName" label="发布人" width="150" sortable="custom">
                  <template slot-scope="scope">
                    <span>{{scope.row.userName}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="postTpCode" label="文章类型" sortable="custom">
                  <template slot-scope="scope">
                    <span v-if="scope.row.postTpCode == '044-001'">三角地</span>
                    <span v-else-if="scope.row.postTpCode == '044-002'">大喇叭</span>
                    <span v-else-if="scope.row.postTpCode == '044-003'">病例分享</span>
                    <span v-else-if="scope.row.postTpCode == '044-004'">病例讨论</span>
                  </template>
                </el-table-column>
<!--                <el-table-column width="150" label="操作">-->
<!--                  <template slot-scope="scope">-->
<!--                    <button type="button" class="eims-button eims-button&#45;&#45;text" style="margin-top: -5px;" @click.stop="handViewClick(scope.row)" >查看</button>-->
<!--                  </template>-->
<!--                </el-table-column>-->
              </el-table>
            </div>

            <span style="float: right">
              <el-pagination
                layout="sizes, prev, pager, next"
                :total="data.list.length"
                :page-size="data.pageSize"
                :page-sizes="data.pageSizeArray"
                @current-change="handlePageChange"
                @size-change="handleSizeChange"
                :current-page="data.pageNum">
              </el-pagination>
            </span>
          </div>
        </div>
      </div >
    </div>

    <common-dialog width="50%" :visible.sync="dialog.isShow" @close="handleCloseDialog">
      <div class="dialog-title" slot="title">
        <template>
          <div class="post-title" >{{ dialog.form.postTitle }}</div>
        </template>
      </div>
      <div class="dialog-body" style="font-size: 16px;line-height: 30px">
        <div style="text-align:right; overflow: auto;">
          <div class="post-userName">{{ dialog.form.userName }}</div>
          <div class="post-time">{{ dialog.form.createTm | dateFormat }}</div>
        </div>
        <div class="post-content" v-html="dialog.form.postContent"/>
      </div>
      <div class="dialog-footer" slot="footer">
        <common-button type="cancel" @click="dialog.isShow = false">取消</common-button>
      </div>
    </common-dialog>
  </section>
</template>

<script>
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import animation from '@/components/loading/animation'
  import PostCreate from "@/components/detail/PostCreate";
  import PostDetail from "@/components/detail/PostDetail";
  import {articleMixin} from "../mixins/articleMixin";
  import PostUpdate from "@/components/detail/PostUpdate";
  import PostApprove from "../../components/detail/PostApprove";
  import {PAGE_SIZE_ARRAY} from '@/constants/constants';

  export default {
    name: "ArticleSearch",
    components:{PostApprove, PostUpdate, PostDetail, animation,PostCreate},
    mixins:[articleMixin],
    data(){
      return{
        data:{
          list:[],
          tableLoading: false,
          isLoading:false,
          pageNum: 1,
          pageSize: 20,
          pageSizeArray: PAGE_SIZE_ARRAY,
          total: 0,
          currentPage: 1,
          //当前登录人
          userId: '',
        },
        dialog:{
          isShow: false,
          form:{
            postTitle: '',
            createTm: '',
            userName: '',
            postContent: '',
          }
        },
        keyword: '',
      }
    },

    mounted() {
      this.keyword = this.$route.query.keyword;
      this.queryAllPublish();
    },

    watch: {
      '$route.query.keyword'(newVal) {
        this.keyword = this.$route.query.keyword;
        this.queryAllPublish();
      }
    },


    methods:{
      handleCloseDialog(){
        this.dialog.isShow = false;
      },

      //返回
      handleCancelClick(){
        this.$router.push({path: '/home'})
      },


      //分页
      handlePageChange(val) {
        this.data.pageNum = val;
        this.queryAllPublish();
      },

      handleSizeChange(val){
        this.data.pageSize = val;
        this.queryAllPublish()
      },

      //查看
      handViewClick(row){
        if (row.postTpCode == '044-003'){
          this.$store.dispatch("findCaseShareDetail",{"postCode": row.postCode,"isDraft": row.isDraft,"postTpCode": row.postTpCode});
          this.$router.push({
            path:"/caseShare/view",
          })
        }else if (row.postTpCode == '044-004'){
          this.$router.push({
            path: "/forum/detail",
            query: {
              id: row.postCode,
            }
          })
        } else {
          this.dialog.isShow = true;
          this.dialog.form = row;
        }
      },

      //查询已发布并审核通过的数据
      queryAllPublish() {
        this.data.tableLoading = true;
        http.post(window.config.api.baseUrl + '/eims-api/article/getArticleByKeyword', {
          token: cookie.getCookie("token"),
          data: {
            // pageNum: this.data.pageNum,
            // pageSize: this.data.pageSize,
            keyword: this.keyword
          }
        }).then(value => {
          if (value.data.code === '00000') {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total
          }
        }).finally(() => {
          this.data.tableLoading = false;

        })
      },

      tableRowClassName({row, rowIndex}) {
        if (rowIndex%2 === 0) {
          return '';
        }
        let clzz = {
          background: '#F3FDFF'+ '!important'
        };
        return clzz;
      },

      sort_change(column) {
        this.data.pageNum = 1
        this.data.sortProp = column.prop
        this.data.sortOrder = column.order
        // if (column.order === 'ascending') {
        //   this.data.sortOrder = 'asc'
        // } else if (column.order === 'descending') {
        //   this.data.sortOrder = 'desc'
        // } else {
        //   this.data.sortorder = 'asc'
        // }

        this.data.list = this.data.list.sort((a, b) => {
          if (column.order === 'descending') {
            return this.SortString(a[column.prop], b[column.prop], -1);
          } else if (column.order === 'ascending') {
            return this.SortString(a[column.prop], b[column.prop], 1);
          }
          return 0;
        });

      },
      SortString(a, b, sortOrder) {
        if (typeof a === 'string' && typeof b === 'string') {
          return a.localeCompare(b) * sortOrder;
        } else if (typeof a === 'number' && typeof b === 'number') {
          return (a - b) * sortOrder;
        } else if (a instanceof Date && b instanceof Date) {
          return (a - b) * sortOrder;
        }
      },
    },

  }
</script>

<style scoped>
  .article-search{
    height: calc(100vh - 109px);
    margin: 20px;
    overflow: hidden;
  }
  .triangle-list-button{
    border: 1px solid rgb(105,185,252);
    border-radius: 3px;
    width: 80px;
    height: 40px;
    text-align: center;
    background-image: url('/static/images/fourbackground.png');
  }
  .loud-speaker-list-table-card{
    height: calc(100vh - 240px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .eims-button {
    font-size: 16px;
  }
  .eims-button--text{
    border-color: transparent;
    color: #409eff;
    background: transparent;
  }
  .eims-button:focus {
    outline: none;
  }
  /deep/ .el-table .cell{
    line-height: unset;
  }

  .LoudSpeaker-list-body-main-button{
    border: 1px solid #3ec4db;
    color: #3ec4db;
    border-radius: 3px;
    width: 80px;
    height: 40px;
    text-align: center;
    font-size: 12px;
    background-image: url('/static/images/fourbackground.png');

  }
  .LoudSpeaker-list-body-main-button:hover{
    background-color: #3ec4db;
    color: white;
  }
  i.icon-file-word-fill{
    color: #008dfa;
    font-size: 40px;
  }
  i.icon-PDF{
    color: #eb5e5e;
    font-size: 40px;
  }
  i.icon-file-excel-fill{
    color: #00c090;
    font-size: 40px;
  }
  i.icon-file-ppt-fill{
    color: #ff7082;
    font-size: 40px;
  }

  .article-panel-box{
    position: relative;
  }

  .article-panel-to-big{
    position: absolute;
    animation-duration: 500ms;
    animation-name: animation-to-big;
    animation-fill-mode: forwards;
  }

  @keyframes  animation-to-big {

    0%{
      width: 0;
    }

    100%{
      width: calc(100vw - 40px);

    }
  }

  .article-panel-to-small{
    position: absolute;
    animation-duration: 500ms;
    animation-name: animation-to-small;
    animation-fill-mode: forwards;
  }

  @keyframes  animation-to-small {

    0%{
      left: 0;
      width: calc(100vw - 40px);

    }

    100%{
      left: calc(100vw - 40px);
      width: 0;
    }
  }




  .title{
    width: 60%;
    display: inline-block;
  }
  .dialog-body{
    margin-top: 5px;
    height: 280px;
    overflow-y: scroll;
    overflow-x:hidden;
    /*将溢出的文本使用...显示*/
    text-overflow:ellipsis;
  }

  /deep/ .el-dialog__body{
    line-height: 1.9!important;
  }

  .triangle-content{
    background: url(../../../static/images/loginbackground.png) no-repeat;
    background-size: 100%;
    height: 200px;
    overflow-y: scroll;
    overflow-x:hidden;
    /*将溢出的文本使用...显示*/
    text-overflow:ellipsis;
    /*border: 1px solid black;*/
    margin-top: 30px;
    /*font-size: 17px;*/
    line-height: 30px;
    display: block;

  }



  /*设置菜单的行高*/
  /deep/ .el-form-item__label {
    line-height: 39px !important;
  }


</style>



// WEBPACK FOOTER //
// src/pages/article/ArticleSearch.vue